import baseColors from '../base/colors'

const colors = {
  ...baseColors,
  red: {
    '100': '#FFF3F5',
    '200': '#FEF3F5',
    '300': '#FDDAE2',
    '400': '#F46D71',
    '500': '#EB0000',
    '600': '#C40000',
    '700': '#9E0000',
    '800': '#710000',
  },
  purple: {
    '200': '#FCF2FB',
    '300': '#F6D7F4',
    '400': '#C670BF',
    '500': '#95098A',
    '600': '#7D0572',
    '700': '#64005A',
    '800': '#4B003F',
  },
  blue: {
    '200': '#F2F8FD',
    '300': '#D8EBF9',
    '400': '#6CA3E1',
    '500': '#005AC8',
    '600': '#0047A5',
    '700': '#003482',
    '800': '#001851',
  },
  teal: {
    '200': '#ECFBFA',
    '300': '#CDFBF7',
    '400': '#69DFDC',
    '500': '#00BEBC',
    '600': '#0096A5',
    '700': '#006E8D',
    '800': '#00445E',
  },
  grey: {
    '000': '#ffffff',
    '50': '#F3F3F4',
    '100': '#E6E7EA',
    '150': '#DADCDF',
    '200': '#CDD0D4',
    '250': '#C1C4C9',
    '300': '#B4B9BF',
    '350': '#A8ADB4',
    '400': '#9BA1A9',
    '450': '#8F959F',
    '500': '#828994',
    '550': '#767E89',
    '600': '#6A727F',
    '650': '#5D6674',
    '700': '#515A69',
    '750': '#444F5F',
    '800': '#384354',
    '850': '#293547',
    '900': '#1F2C3E',
    '950': '#122034',
    '1000': '#061429',
  },
  errorRed: {
    '200': '#FBE7EA',
    '300': '#F7CED6',
    '400': '#EF9EAD',
    '500': '#E66D83',
    '600': '#DE3D5A',
    '700': '#D60C31',
    '800': '#BD0022',
  },
  orange: {
    '200': '#FFF5EC',
    '300': '#FEEBDA',
    '400': '#FED7B4',
    '500': '#FDC38F',
    '600': '#FCB069',
    '700': '#FB9C44',
    '800': '#E36D00',
  },
  green: {
    '200': '#E9F3ED',
    '300': '#D2E7DB',
    '400': '#A5D0B6',
    '500': '#79B892',
    '600': '#4CA16D',
    '700': '#1F8949',
    '800': '#016D2C',
  },
}

export default colors
